
export default {
    state: {
        host: "192.168.10.105"
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
    }
}
